export default __webpack_public_path__ + "static/media/layout01.8edeaa95.png";